export default __webpack_public_path__ + "assets/icons/message_info.93073119.svg";